import { loadProfile } from '../content/loadProfile'

function FocusLine({ text }) {
  const sep = ' — '
  const index = text.indexOf(sep)
  if (index === -1) {
    return <p data-testid="home-focus">{text}</p>
  }

  return (
    <p data-testid="home-focus">
      {text.slice(0, index + sep.length)}
      <span className="home-focus__tagline">{text.slice(index + sep.length)}</span>
    </p>
  )
}

export default function HomeSection() {
  const profile = loadProfile()

  return (
    <section id="home" data-testid="home" className="section section--home">
      <div className="home-hero" data-testid="home-atmosphere">
        <h1 data-testid="home-name">{profile.displayName}</h1>
        <FocusLine text={profile.roleOrFocus} />
        <p data-testid="home-intro">{profile.shortIntro}</p>
        <p className="home-ctas">
          <a href="#work" data-testid="home-cta-work" className="home-cta home-cta--primary">
            See the work
          </a>
          <a href="#contact" data-testid="home-cta-contact" className="home-cta">
            Contact
          </a>
        </p>
      </div>
    </section>
  )
}
